import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnNL: CultureInfo = {
  name: 'en-NL',
  displayName: 'English (Netherlands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-NL',
  parent: CultureInfoEn
};
